import { render, staticRenderFns } from "./arbitrate.vue?vue&type=template&id=2acc0c88&scoped=true&"
import script from "./arbitrate.vue?vue&type=script&lang=js&"
export * from "./arbitrate.vue?vue&type=script&lang=js&"
import style0 from "./arbitrate.vue?vue&type=style&index=0&id=2acc0c88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acc0c88",
  null
  
)

export default component.exports